import { cn } from "@monbits/ui";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export type StatusType =
	| "success"
	| "warning"
	| "error"
	| "info"
	| "default"
	| "danger";

interface StatusBadgeProps {
	children: ReactNode;
	type?: StatusType;
	className?: string;
	icon?: LucideIcon;
}

const statusStyles: Record<StatusType, string> = {
	success: "border-(--success-border) bg-(--success-bg) text-(--success-fg)",
	warning: "border-(--warning-border) bg-(--warning-bg) text-(--warning-fg)",
	error: "border-(--error-border) bg-(--error-bg) text-(--error-fg)",
	info: "border-(--info-border) bg-(--info-bg) text-(--info-fg)",
	default: "border-(--neutral-border) bg-(--neutral-bg) text-(--neutral-fg)",
	danger: "border-(--error-border) bg-(--error-bg) text-(--error-fg)",
};

export function StatusBadge({
	children,
	type = "default",
	className,
	icon: Icon,
}: StatusBadgeProps) {
	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded border px-2.5 py-0.5 text-xs font-medium transition-colors",
				statusStyles[type],
				className,
			)}
		>
			{Icon && <Icon className="h-3.5 w-3.5" />}
			{children}
		</span>
	);
}
